import BrandShipping from './BrandShipping';
import ClothsDetails from './ClothsDetails';
import ImageSlider from './ImageSilder';
import ProductDetails from './ProductDetails';
import { Card, CardBody, Col, Container, Row } from 'reactstrap';
import { Fragment, useEffect, useState } from 'react';
import NavbarsTab from '../../../../A-RKS/NavBar';
import { getProductDetail } from '../../../../CommonUrl';
import { getClientUrlDataToken } from '../../../../Utils/restUtils';
import { useLocation } from 'react-router';
import Transparentspinner from '../../../Common/Loader/Transparentspinner';

const ProductPageContain = () => {
    const location = useLocation();
    const { id } = location.state || {};
    const [apiResponse, setapiResponse] = useState(null);
    const [attributeImageUrls, setAttributeImageUrls] = useState([]);
    const [loading,setLoading]=useState(false)

    const handleAttributeImageUpdate = (attributeOption) => {
        // Filter only items with an image
        const imageList = attributeOption
            .filter((attr) => attr.image)
            .map((attr) => ({ image_url: attr.image }));

        setAttributeImageUrls(imageList);
    };
    const baseImageUrls = [
        { image_url: apiResponse?.item_image },
        ...(apiResponse?.additional_images || []).map(img => ({
            image_url: img.image_url
        }))
    ];

    const finalImageUrls = [...baseImageUrls, ...attributeImageUrls];

    useEffect(() => {
        fetchDashboardData();
    }, []);

    const fetchDashboardData = async () => {
        setLoading(true)
        const response = await getClientUrlDataToken(getProductDetail + `?product_id=${id}`);
        setapiResponse(response?.data);
        setLoading(false)
    }

    return (
        <>
            <NavbarsTab />
            {
                loading ?
                <Transparentspinner/>:
            <Fragment>

                {/* <Breadcrumbs title="Product Page" mainTitle="Product Page" parent="Ecommerce" /> */}
                <Container fluid={true} className='mt-20'>
                    <div>
                        <Row className="product-page-main p-0">
                            <Col xl="5" md="6" className="box-col-7 xl-50">
                                <Card>
                                    <CardBody>
                                        {/* <Row> */}
                                        <ImageSlider apiImages={finalImageUrls} />
                                        {/* </Row> */}
                                    </CardBody>
                                </Card>
                            </Col>
                            <ProductDetails apiDetail={apiResponse} onAttributeImageChange={handleAttributeImageUpdate} />
                            {/* <BrandShipping /> */}
                        </Row>
                    </div>
                    {/* <Card>
                        <Row className="product-page-main">
                            <Col sm="12">
                                <ClothsDetails />
                            </Col>
                        </Row>
                    </Card> */}
                </Container>
            </Fragment>

            }
        </>
    );
};
export default ProductPageContain;